import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/cn.js';
export const buttonVariants = cva('inline-flex items-center justify-center rounded-[var(--radius-2)] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-border-focus)] disabled:pointer-events-none disabled:opacity-50', {
    variants: {
        variant: {
            primary: 'bg-[var(--color-brand-bg)] text-[var(--color-brand-fg)] hover:bg-[var(--color-brand-bg-hover)]',
            secondary: 'bg-[var(--color-surface-raised)] text-[var(--color-text-primary)] hover:bg-[var(--color-surface-overlay)]',
            ghost: 'text-[var(--color-text-primary)] hover:bg-[var(--color-surface-sunken)]',
            danger: 'bg-[var(--color-state-danger-bg)] text-[var(--color-state-danger-fg)] hover:bg-[var(--color-state-danger-bg-hover)]',
        },
        size: {
            sm: 'h-8 px-3 text-sm',
            md: 'h-10 px-4 text-sm',
            lg: 'h-12 px-6 text-base',
            icon: 'h-8 w-8',
        },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
});
export const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { ref: ref, className: cn(buttonVariants({ variant, size }), className), ...props }));
});
Button.displayName = 'Button';
//# sourceMappingURL=button.js.map